export default "__VITE_ASSET__CeVxW6PI__"